export enum DATA_ACCESS_PERMISSIONS_ACTIONS {
	READ = 'read',
	CREATE = 'create',
	UPDATE = 'update',
	DELETE = 'delete',
	READALL = 'readAll',
	UPDATEALL = 'updateAll',
	EDITLABEL = 'Edit',
	CREATELABEL = 'Create',
}
